export default __webpack_public_path__ + "static/media/Boots of the Savage Fang.85a0f3cd.jpg";